<template>
    <div>
        <div v-if="!isEdit" class="txt-nowrap d-flex align-center">
            <span class="font-weight-bold">C = </span>
            <div class="ml-2" style="display: inline-flex; flex-direction: column; align-items: center;">
                <div style="display: inline-block">
                    (<span class="font-weight-bold">M</span>
                    &#177; {{ getRateAdditional }}) &#215;{{ getRateIndex }}
                    &#177; {{ getRateSupplement }}
                </div>
                <div
                    class="w-100 d-flex"
                    style="border-top: 1px solid #6c757d"
                    v-if="getRoomRateDerivationsDenominatorList.length > 0"
                >
                    <template v-for="(denominatorList, index) in getRoomRateDerivationsDenominatorList">
                        <div :key="index">
                            (1 &#8722;
                            {{ denominatorList }} &#37;)
                            <span
                                class="px-1"
                                v-if="index < getRoomRateDerivationsDenominatorList.length - 1"
                            >
                                &#215;
                            </span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="isEdit">
            <div class="txt-nowrap d-flex align-center">
                <div class="mr-1">
                    <span class="font-weight-bold">C =</span>
                </div>
                <div>
                    <div
                    class="d-flex align-center d-multiplier txt-nowrap justify-content-center ch-28"
                    >
                    <div class="mr-1">
                        <span class="font-weight-bold">
                            (M &#177;
                        </span>
                    </div>
                    <div>
                        <number-ptd
                        class="input-plus fs-10"
                        :class="classInput"
                        :options="
                            usedCurrency == 'VND'
                            ? priceOptionsVi
                            : priceOptionsEn
                        "
                        dense
                        :outlined="false"
                        v-model="getRateAdditional"
                        :rules="ruleRequiedNoMess"
                        :allowMinusNumber="true"
                        />
                    </div>
                    <span class="font-weight-bold pr-1">
                        ) &#215;
                    </span>
                    <div class="mr-1">
                        <number-ptd
                        class="input-multiplier"
                        :class="classInput"
                        :options="multiplierOption"
                        dense
                        :outlined="false"
                        v-model="getRateIndex"
                        :rules="ruleRequiedNoMess"
                        />
                    </div>
                    <span
                        class="font-weight-bold pl-1 pr-1"
                    >
                        &#177;
                    </span>
                    <div class="ml-1">
                        <number-ptd
                        class="input-plus"
                        :class="classInput"
                        :options="
                            usedCurrency == 'VND'
                            ? priceOptionsVi
                            : priceOptionsEn
                        "
                        dense
                        :outlined="false"
                        v-model="getRateSupplement"
                        :rules="ruleRequiedNoMess"
                        :allowMinusNumber="true"
                        />
                    </div>
                    </div>
                    <template v-if="getRoomRateDerivationsDenominatorList.length > 0">
                    <div
                        class="w-100 d-flex align-center d-multiplier txt-nowrap justify-content-center ch-28"
                        style="border-top: 1px solid #6c757d"
                    >
                        <template v-for="(denominatorList, index) in getRoomRateDerivationsDenominatorList">
                        <div
                            class="d-flex align-center txt-nowrap font-weight-bold"
                            :key="index"
                        >
                            <div class="mr-1">
                            <span class="font-weight-bold"
                                >(1 &#8722;</span
                            >
                            </div>
                            <div>
                            <number-ptd
                                class="cw-50 fs-10"
                                :class="classInput"
                                :options="custormInput"
                                dense
                                :outlined="false"
                                v-model="getRoomRateDerivationsDenominatorList[index]"
                                :rules="ruleRequiedNoMess"
                                :valueWhenIsEmpty="'0'"
                            />
                            </div>
                            <span
                            class="font-weight-bold pr-1"
                            >)
                            <span v-if="index < getRoomRateDerivationsDenominatorList.length - 1">&#215;</span>
                            </span>
                        </div>
                        </template>
                    </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import numberInput from "@/components/Utils/Number-input.vue";
export default {
    props: {
        isEdit: {
            type: Boolean,
            default: false
        },
        roomRateDerivationsDenominatorList: {
            type: Array,
            default: () => []
        },
        rateAdditional: {
            type: String | Number,
            default: 0
        },
        rateIndex: {
            type: String | Number,
            default: 1
        },
        rateSupplement: {
            type: String | Number,
            default: 0
        },
        classInput: {
            type: String,
            default: ''
        }
    },
    components: {
        "number-ptd": numberInput
    },
    data() {
        return {
            multiplierOption: {
                prefix: "",
                locale: "vi",
                length: 3,
                precision: 2,
            },
            custormInput: {
                suffix: `%`,
                locale: this.$i18n.locale,
                precision: 2,
                length: 4,
                checkPercentage: true
            }
        }
    },
    methods: {

    },
    computed: {
        getRateAdditional: {
            get() {
                return this.rateAdditional;
            },
            set(newVal) {
                this.$emit('changeRateAdditional', newVal);
            }
        },
        getRateSupplement: {
            get() {
                return this.rateSupplement;
            },
            set(newVal) {
                this.$emit('changeRateSupplement', newVal);
            }
        },
        getRateIndex: {
            get() {
                return this.rateIndex;
            },
            set(newVal) {
                this.$emit('changeRateIndex', newVal);
            }
        },
        getRoomRateDerivationsDenominatorList: {
            get() {
                return this.roomRateDerivationsDenominatorList;
            },
            set(newVal) {
                this.$emit('changeRateDerivationsDenominatorList', newVal);
            }
        }
    }
}
</script>